import { Navigate, useParams } from 'react-router-dom';

/**
 * Redirect for a legacy URL prefix: forwards whatever follows the matched
 * prefix onto the new one (`/admin/lists/:id/edit` → `/admin/collection/:id/edit`).
 * Mount it on a `<prefix>/*` route. Same home as `ParamRedirect`, for the same
 * react-refresh reason.
 */
export default function SplatRedirect({ to }: { to: string }) {
  const { '*': rest = '' } = useParams();
  return <Navigate to={rest ? `${to}/${rest}` : to} replace />;
}
